import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { profileAction, userAction } from "@redux/modules";

import { FaCoins } from 'react-icons/fa';

// Format Date
import moment from 'moment';

const Score = () => {
  const dispatch = useDispatch();
  // Point All Datatable Items
  const pointHistoryAll = useSelector((store) => store.profile.pointHistoryAll);
  const totalCharityScore = useSelector(
    (store) => store.profile.profileDetail?.score
  );
  const totalEarnedScore = useSelector(
    (store) => store.profile.profileDetail?.totalScore
  );
  const [state, setState] = useState({
    transactionsCount: 10,
  });

  // Puanı AZALTAN işlem tipleri (kırmızı + eksi gösterilir).
  // Diğer tüm tipler kazanç sayılır (yeşil + artı). scoreType display adı
  // ("SİPARİŞ") değil, scoreTypeEnum (enum adı) ile karşılaştırılır.
  const SUBTRACTION_SCORE_TYPES = ["PUAN_SILME", "SIPARIS", "MARKA_URUNU_SIPARIS"];
  const isSubtraction = (item) =>
    SUBTRACTION_SCORE_TYPES.includes(item.scoreTypeEnum);

  useEffect(() => {
    dispatch(profileAction.getScore());
    dispatch(profileAction.getProfileAllPointHistory());
  }, []);

  const handleLoadMore = (event) => {
    event.preventDefault();
    setState({
      ...state,
      transactionsCount:
        (state.transactionsCount ? state.transactionsCount : 10) + 10,
    });
  };

  return (
    <>
      <React.Fragment>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-sm-6 mb-4">
          <h2 className="mb-0"> Puan Geçmişim</h2>
          <div className="d-flex align-items-center flex-wrap gap-2">
            <span className="badge rounded-pill bg-green px-3 py-2 fs-6">
              Toplam Kazanılan Puan: <FaCoins className="text-white" /> {totalEarnedScore || 0}
            </span>
            <span className="badge rounded-pill bg-blue px-3 py-2 fs-6">
              Mevcut Puan: <FaCoins className="text-white" /> {totalCharityScore || 0}
            </span>
          </div>
        </div>
        <p className="mb-sm-5 mb-4 fw-light">
          Kazandığınız puanları bu bölümde detaylı olarak görebilir, takip
          edebilirsiniz.
        </p>

        {pointHistoryAll
          ? pointHistoryAll?.content
              ?.slice(0, state.transactionsCount ? state.transactionsCount : 10)
              .map((item, i) => (
                <div
                  className="d-flex align-items-center justify-content-between py-3 border-bottom"
                  key={i}
                >
                  <span className="text-blue-light">
                    {moment(item.dateCreated).format("DD.MM.YYYY - HH:mm")}
                  </span>
                  <span className="mx-4">{item.scoreType}</span>
                  {isSubtraction(item) ? (
                    <span className="badge rounded-pill bg-red px-3 py-2 ms-auto">
                      -{item.changedScore} Puan
                    </span>
                  ) : (
                    <span className="badge rounded-pill bg-green px-3 py-2 ms-auto">
                      +{item.changedScore} Puan
                    </span>
                  )}
                </div>
              ))
          : null}
        {pointHistoryAll?.content?.length -
          (state.transactionsCount ? state.transactionsCount : 10) >
        0 ? (
          <div className="text-center mt-sm-6 mt-5">
            <button
              type="button"
              className="btn btn-blue rounded-pill py-sm-3 py-2 px-sm-4 px-3"
              onClick={(event) => handleLoadMore(event)}
            >
              Daha Fazla Göster
            </button>
          </div>
        ) : null}
      </React.Fragment>
    </>
  );
};

export default Score;
